import { render, staticRenderFns } from "./escaperoom.vue?vue&type=template&id=262600c1&scoped=true&"
import script from "./escaperoom.vue?vue&type=script&lang=js&"
export * from "./escaperoom.vue?vue&type=script&lang=js&"
import style0 from "./escaperoom.vue?vue&type=style&index=0&id=262600c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262600c1",
  null
  
)

export default component.exports